import { Box, Grid } from '@material-ui/core'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useGeneralContext } from './contexts/GeneralContext'
import { navDirections } from './utils/navDirections'
import zoology from '../Assets/zoology.svg'
import maths from '../Assets/maths.svg'
import botony from '../Assets/botony.svg'
import physics from '../Assets/physics.svg'
import computer from '../Assets/computer.svg'
import chemistry from '../Assets/chemistry.svg'
import { useAuthContext } from './contexts/AuthContext'
import { subjectNames, subjectNS } from './utils/chapter'

function OnlineClass() {
    const { setSubSelected } = useGeneralContext()
    const { userDetails } = useAuthContext()

    const history = useHistory()

    const onSelection = (sub) => {
        setSubSelected(sub)
        history.push(navDirections.ONLINE_CLASS_SUBJECT)
    }

    const createSubjects = () => {
        return [
            {
                img: maths,
                name: subjectNames[subjectNS.MATHS],
                ns: subjectNS.MATHS,
                active: true
            },
            {
                img: physics,
                name: subjectNames[subjectNS.PHYSICS],
                ns: subjectNS.PHYSICS,
                active: true
            },
            {
                img: chemistry,
                name: subjectNames[subjectNS.CHEMISTRY],
                ns: subjectNS.CHEMISTRY,
                active: true
            },
            {
                img: zoology,
                name: subjectNames[subjectNS.ZOOLOGY],
                ns: subjectNS.ZOOLOGY,
                active: userDetails?.stream === 'Biology Science'
            },
            {
                img: botony,
                name: subjectNames[subjectNS.BOTANY],
                ns: subjectNS.BOTANY,
                active: userDetails?.stream === 'Biology Science'
            },
            {
                img: computer,
                name: subjectNames[subjectNS.COMPUTER_SCIENCE],
                ns: subjectNS.COMPUTER_SCIENCE,
                active: userDetails?.stream === 'Computer Science'
            }
        ]
    }

    return (
        <SubjectContainer>
            <Heading>Subjects</Heading>
            <Box
                my={5}
                display="flex"
                alignItems="center"
                flexDirection="column"
                maxWidth="500px"
                mx="auto"
            >
                <Grid
                    container
                    spacing={2}
                    justify="center"
                    alignItems="center"
                >
                    {createSubjects().map((sub) => (
                        <Grid item xs={6} my={1} key={sub.name}>
                            <SubjectCard
                                onClick={() =>
                                    sub.active ? onSelection(sub.ns) : {}
                                }
                            >
                                <CardImage>
                                    <img src={sub.img} alt={sub.name} />
                                </CardImage>
                                <CardText>{sub.name}</CardText>
                            </SubjectCard>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </SubjectContainer>
    )
}

const SubjectContainer = styled.div`
    padding-top: 20px;
    margin-bottom: 50px;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    margin: 30px 0;
    font-size: 24px;
    z-index: 1;
`

const SubjectCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 150px;
    height: 150px;
    margin: 8px auto;
    background: linear-gradient(
            314.55deg,
            rgba(255, 255, 255, 0.05) 2.86%,
            rgba(255, 255, 255, 0) 93.11%
        ),
        linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    border-radius: 15px;
    position: relative;
    cursor: pointer;

    transition: transform ease-in-out 0.2s;

    &:hover {
        transform: scale(1.02);
    }
    &:active {
        transform: scale(0.98);
    }
`
const CardText = styled.p`
    color: #fff;
    font-weight: 500;
    margin-top: 1.2rem;
    font-size: 14px;
`
const CardImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 60px;
    img {
        width: 100%;
    }
`
export default OnlineClass
